var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"scroll","max-height":"80vh"}},[_c('router-view',{attrs:{"name":"action"}}),_c('router-view',{attrs:{"name":"view"}}),_c('app-footer'),_c('confirmation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }